import { NgModule } from '@angular/core';

import { MenuItems } from './menu-items/menu-items';
import { HorizontalMenuItems } from './menu-items/horizontal-menu-items';

import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogSuspendComponent } from './components/confirm-dialog-suspend/confirm-dialog-suspend.component';
import { DemoMaterialModule } from '../demo-material-module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { CommonModule } from '@angular/common';
import { BlockUIComponent } from './components/block-ui/block-ui.component';
import { PurchaseConfirmComponent } from './components/purchase-confirm/purchase-confirm.component';
import { UploadFilesComponent } from './components/upload-Files/upload-files.component';
import { DialogService } from './services/dialog.service';
import { FilesViewComponent } from './components/files-view/files-view.component';
import { DropzoneModule } from 'ngx-dropzone-wrapper';
import { BulkDataUploadComponent } from './components/bulk-data-upload/bulk-data-upload.component';
import { BulkDataUploadTableComponent } from './components/bulk-data-upload/bulk-data-upload-table/bulk-data-upload-table.component';
import { ImageViewerDialogComponent } from './components/image-viewer-dialog/image-viewer-dialog.component';

/* import { MatTimepickerModule } from 'mat-timepicker'; */

@NgModule({
    imports: [
        CommonModule,
        DemoMaterialModule,
        FlexLayoutModule,
        FormsModule,
        MatListModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        DropzoneModule,
        /* MatTimepickerModule, */
    ],
    declarations: [
        AccordionAnchorDirective,
        AccordionLinkDirective,
        AccordionDirective,
        ConfirmDialogComponent,
        ConfirmDialogSuspendComponent,
        BlockUIComponent,

        PurchaseConfirmComponent,

        UploadFilesComponent,

        FilesViewComponent,

        BulkDataUploadComponent,

        BulkDataUploadTableComponent,

        ImageViewerDialogComponent,
    ],
    exports: [AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective, BlockUIComponent],
    providers: [MenuItems, HorizontalMenuItems, DialogService],
})
export class SharedModule {}
